import React, { useState, useEffect  } from 'react'
import axios from 'axios';
function FooterBanner() {
const [posts, setPosts] = useState([]);
const [loading, setLoading] = useState(false);
let api = 'https://tallysolutions-uae.com/tallyprime/api/wp-json/wp/v2/footer_banner?per_page=1';
useEffect(() => {
setLoading(true)
axios.get(api)
.then(res => {
//console.log(res)
setPosts(res.data)
setLoading(false)
})
}, [setPosts])
return (
<React.StrictMode>
   {
   loading && 
   <section className="bg-white pt-5"><img src="https://tallysolutions-uae.com/tallyprime//assets/img/loading.gif" alt="loading" className="mx-auto d-block mt-5 pt-5" width="20" /></section>
   }
   {!loading &&
   <>
   {posts.map((post,i) => (
   <span   dangerouslySetInnerHTML={{ __html: post.content.rendered }} />
   ))}
   </>
   }
</React.StrictMode>
)
}
export default FooterBanner;


